export default class RefreshData {
    constructor() {
        this.Method = "";
        this.OrganizationId = "";
        this.UserIds = [];
        this.RoleIds = [];
    }
}
